<template>
    <div>
        <v-container style="text-align:center">
            <div
                v-show="
                    !alreadyReplied() &&
                        schedule[0].one_answer == 'yes' &&
                        !datePassed()
                "
            >
                <p>Username: {{ schedule[0].username }}</p>
                <v-text-field placeholder="ditt namn" v-model="name" />
                <div v-show="schedule[0].ask_for_contact === 'yes'">
                    <v-text-field
                        v-for="(det, i) in contact"
                        :key="i"
                        :label="det"
                        v-show="det"
                        v-model="ci[i]"
                    />
                </div>
                <v-textarea placeholder="Kommentarer" v-model="comment" />
                <v-row
                    ><v-card
                        class="card"
                        v-for="(date, i) in selectedDates"
                        :key="date.id"
                    >
                        <v-card-title>{{ toDDMMYY(date.date) }}</v-card-title>
                        <h5>
                            <v-card-subtitle
                                >{{ toMMHH(date.time_from) }} -
                                {{ toMMHH(date.time_to) }}</v-card-subtitle
                            >
                        </h5>
                        <v-card-text>
                            <v-radio-group
                                style="display:flex"
                                v-model="date.status"
                            >
                                <v-row>
                                    <v-radio
                                        class="radio"
                                        v-for="(checkbox, i) in checkBoxes"
                                        :key="i"
                                        :label="checkbox.label"
                                        :value="checkbox.value"
                                    />
                                </v-row>
                            </v-radio-group>
                            <v-text-field
                                label="Comment"
                                v-model="dateComments[i].comment"
                            />
                        </v-card-text>
                    </v-card>
                </v-row>
                <v-btn
                    style="background-color:#ffa500;margin-bottom:20px"
                    @click="submit"
                    >Sända
                    <v-icon style="margin-left:3px;font-size:15px">
                        fas fa-check</v-icon
                    ></v-btn
                >
            </div>
            <div>
                <p v-show="alreadyReplied() ">
                    Du har redan svarat på detta schema
                </p>
                <p v-if="datePassed()">
                    Svardatum för schemat passeras
                </p>
            </div>
            <div v-if="schedule[0].one_answer == 'no' && !datePassed()">
                <p>Username: {{ schedule[0].username }}</p>
                <v-text-field placeholder="ditt namn" v-model="name" />
                <div v-show="schedule[0].ask_for_contact === 'yes'">
                    <v-text-field
                        v-for="(det, i) in contact"
                        :key="i"
                        :label="det"
                        v-show="det"
                        v-model="ci[i]"
                    />
                </div>
                <v-textarea placeholder="Kommentarer" v-model="comment" />
                <v-row
                    ><v-card
                        class="card"
                        v-for="(date, i) in selectedDates"
                        :key="date.id"
                    >
                        <v-card-title>{{ toDDMMYY(date.date) }}</v-card-title>
                        <h5>
                            <v-card-subtitle
                                >{{ toMMHH(date.time_from) }} -
                                {{ toMMHH(date.time_to) }}</v-card-subtitle
                            >
                        </h5>
                        <v-card-text>
                            <v-radio-group
                                style="display:flex"
                                v-model="date.status"
                            >
                                <v-row>
                                    <v-radio
                                        class="radio"
                                        v-for="(checkbox, i) in checkBoxes"
                                        :key="i"
                                        :label="checkbox.label"
                                        :value="checkbox.value"
                                    />
                                </v-row>
                            </v-radio-group>
                            <v-text-field
                                label="Comment"
                                v-model="dateComments[i].comment"
                            />
                        </v-card-text>
                    </v-card>
                </v-row>
                <v-btn
                    style="background-color:#ffa500;margin-bottom:20px"
                    @click="submit"
                    >Sända
                    <v-icon style="margin-left:3px;font-size:15px">
                        fas fa-check</v-icon
                    ></v-btn
                >
            </div>

            <v-simple-table style="border:solid;padding:8px">
                <thead>
                    <tr>
                        <th style="font-size:20px">Tid</th>
                        <th style="font-size:20px">Kommentarer</th>
                        <th v-for="date in dates" :key="date.id">
                            <p
                                style="font-size:30px;color:white;background-color:orange;max-width:130px;border-radius:5px;padding:2px"
                            >
                                {{ toDDMMYY(date.schedule_date) }}
                            </p>
                            <p style="font-size:15px">
                                {{ toMMHH(date.time_from) }} to
                                {{ toMMHH(date.time_to) }}
                            </p>
                        </th>
                        <th
                            v-for="det in contact"
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            :key="det"
                        >
                            {{ det }}
                        </th>
                    </tr>
                    <tr>
                        <th style="font-size:15px">Deltagarens namn</th>
                    </tr>
                    <tr
                        v-for="participant in participation_table"
                        :key="participant.id"
                        style="text-align:left"
                    >
                        <td>{{ participant.name }}</td>
                        <td>{{ participant.comment }}</td>
                        <td v-for="date in participant.dates" :key="date.id">
                            <p v-if="date.status == 1">
                                <v-icon style="margin-left:10px;color:green"
                                    >fas fa-check</v-icon
                                >
                            </p>
                            <p v-else-if="date.status == 0">
                                <v-icon style="margin-left:10px;color:red"
                                    >fas fa-times</v-icon
                                >
                            </p>
                            <p v-else>Om det behövs</p>
                            <p>{{ date.comment }}</p>
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci0 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci1 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci2 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci3 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci4 }}
                        </td>
                    </tr>
                </thead>
            </v-simple-table>
        </v-container>
        <v-container
            style="text-align:center;border:1px solid;max-width:700px;margin-top:10px"
        >
            <h4>Alla med länken kan rösta - inget konto behövs</h4>
            <br />
            <p>
                {{ copyLink() }}
                <v-btn v-clipboard="copyLink" text>
                    <v-icon>fas fa-copy</v-icon>
                </v-btn>
            </p>
        </v-container>
    </div>
</template>

<script>
export default {
    props: ["store"],
    data: function() {
        return {
            schedule: {},
            dates: [],
            participants: [],
            participant_dates: [],
            participation_table: [],
            dateComments: [],
            name: "",
            selectedDates: [],
            comment: "",
            email: "",
            phone: "",
            shareLink: "",
            ci: [],
            checkBoxes: [
                {
                    label: "Ja",
                    value: 1
                },
                {
                    label: "Nej",
                    value: 0
                },
                {
                    label: "Om det behövs",
                    value: 2
                }
            ]
        };
    },
    async created() {
        (this.schedule = this.store.state.getSchedule.details),
            (this.link = this.store.state.getSchedule.details[0].link);
        (this.dates = this.store.state.getSchedule.dates),
            (this.participants = this.store.state.getSchedule.participants),
            (this.participant_dates = this.store.state.getSchedule.participantDates);
        this.shareLink = `https://tid.nu/schedule/${this.store.state.link}`;
        for (var i = 0; i < this.participants.length; i++) {
            var participant = {
                id: i,
                name: this.participants[i].name,
                comment: this.participants[i].comment,
                dates: [],
                ci0: this.participants[i].ci0,
                ci1: this.participants[i].ci1,
                ci2: this.participants[i].ci2,
                ci3: this.participants[i].ci3,
                ci4: this.participants[i].ci4
            };
            for (var j = 0; j < this.participant_dates.length; j++) {
                if (
                    this.participants[i].id ===
                    this.participant_dates[j].participant_id
                )
                    participant.dates.push({
                        date: this.participant_dates[j].id,
                        status: this.participant_dates[j].participant_status,
                        comment: this.participant_dates[j].comment
                    });
            }
            this.participation_table = [
                ...this.participation_table,
                participant
            ];
            participant = { id: 0, name: "", dates: [] };
        }
        for (i = 0; i < this.dates.length; i++) {
            this.selectedDates[i] = {
                id: this.dates[i].id,
                date: this.dates[i].schedule_date,
                time_from: this.dates[i].time_from,
                time_to: this.dates[i].time_to,
                status: null
            };
        }

        this.selectedDates.forEach(date => {
            this.dateComments.push({ id: date.id, comment: "" });
        });

        this.contact = [
            this.schedule[0].contact_info1,
            this.schedule[0].contact_info2,
            this.schedule[0].contact_info3,
            this.schedule[0].contact_info4,
            this.schedule[0].contact_info5
        ];
    },
    methods: {
        submit: async function() {
            let bodyFormData = new FormData();
            await bodyFormData.append(
                "dates",
                JSON.stringify({ dates: this.selectedDates })
            );
            await bodyFormData.append(
                "schedule_id",
                this.store.state.getSchedule.details[0].id
            );
            if (this.store.state.user.id)
                await bodyFormData.append("user_id", this.store.state.user.id);
            else await bodyFormData.append("user_id", 0);
            await bodyFormData.append("name", this.name);
            await bodyFormData.append("comment", this.comment);
            await bodyFormData.append(
                "DateComments",
                JSON.stringify(this.dateComments)
            );
            for (var i = 0; i < 5; i++) {
                if (this.ci[i] != null)
                    bodyFormData.append(`ci${i}`, this.ci[i]);
            }
            if (this.email) await bodyFormData.append("email", this.email);
            if (this.phone) await bodyFormData.append("phone", this.phone);
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("addParticipant", config);
            window.location.reload();
        },
        alreadyReplied: function() {
            return this.participants.some(
                part => part.user_id == this.store.state.user.id
            );
        },
        copyLink: function() {
            return this.shareLink;
        },
        datePassed: function() {
            if (this.schedule[0].reply_deadline == "no") return false;

            let date = new Date(Date.now());
            let replyDeadline = new Date(this.schedule[0].reply_deadline_date);
            return date > replyDeadline;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        }
    }
};
</script>

<style scoped>
.card {
    max-width: 600px;
    height: 300px;
    padding: 10px;
    margin: 20px;
}
.radio {
    margin: 2px;
    padding: 2px;
}
</style>
